import { financeApi } from '../../api';

export interface ICoupons {
  name: string;
  initialValidity: string;
  endValidity: string;
  discountType: string;
  value: number;
}

export async function createCoupons(data: ICoupons): Promise<ICoupons | false> {
  try {
    const response = await financeApi.post<ICoupons>(`/coupons`, data);
    const coupons = response.data;
    return coupons;
  } catch (err) {
    console.error(
      `Ocorreu algum problema ao criar o cupom, atualize a página e tente novamente 😕`,
      err,
    );
    return false;
  }
}
